import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ValidationModal({
  open,
  onClose,
  color,
  bgcolor,
  warningAndErrorsData = [],
}) {
  return (
    <Modal
      open={!!open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        onClose();
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          overflow: "auto",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
        }}
      >
        {/* Modal Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          px={2.5}
          pt={2.5}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography fontWeight={"semibold"} variant="subtitle1" color="text.primary">
              All Warnings & Errors
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ background: "#E0E0E0" }} />

        <Box
          maxHeight={500}
          display="flex"
          flexDirection="column"
          gap={1}
          p={2.5}
          mb={4}
          overflow="auto"
          bgcolor={bgcolor}
          color={color}
        >
          <List sx={{ listStyleType: "disc", pl: 2 }}>
            {warningAndErrorsData.map((item, index) => {
              if(item?.code === "MAX_ERRORS") return null;
              return (<ListItem
                key={`modal-item-${index}`}
                sx={{ display: "list-item", p: 0 }}
              >
                <ListItemText
                  primary={`Row ${item.lineNumber}: ${item?.messages?.join(", ")}`}
                  primaryTypographyProps={{ variant: "body2" }}
                />
              </ListItem>)
            })}
          </List>

          {warningAndErrorsData[warningAndErrorsData.length -1]?.code === "MAX_ERRORS" && (
            <Typography fontWeight={"bold"} variant="body2" color={color}>
              Only first 100 errors/warnings are shown here. Please fix them and re-upload the file.
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
